//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { MediaTypeOverlayIconType } from '@components/atoms/overlay-icon/MediaTypeOverlayIcon';
import Cuid from '@models/Cuid';
import { IInstagramPost } from '@models/IInstagramMediaItem';
import PostableId from '@models/PostableId';
import { Normalized } from '@utils/normalize';

export interface IInstagramScheduleFeedPreviewState {
  errors: {
    fetchLivePostsError?: string;
  };
  flags: {
    isFetchingLivePosts: boolean;
  };
  livePosts: Normalized<IInstagramPost, string>;
}

export interface IFeedPreviewItem {
  cuid: Cuid;
  imageUrl: string;
  mediaType: FeedPreviewMediaOverlayIconType;
  postId?: PostableId;
  scheduledTime?: Date;
  postedTime?: number;
}

export type FeedPreviewMediaOverlayIconType = Exclude<
  MediaTypeOverlayIconType,
  'story' | 'gif'
>;

// We want to show 5 full rows of existing posts in the feed preview,
// meaning we need between 15-17 to fill out the rows.
export const FEED_PREVIEW_LIVE_POST_LIMIT = 17;
